<template>
  <!-- ホーム画面 -->
  <div id="InspectorHome">
    <!-- 上部余白 -->
    <div style="height: 10px;" />
    <div style="margin-left: 50px; margin-right: 50px;">
      <div class="messageSpace title is-6" v-if="healthChecker==0">
        <p>本日点検はできません。上長へ相談しましょう。</p>
      </div>
      <div class="alert title is-6" v-if="isShowtAlert || isShowtAlertNoDetail">
        <div>
          <p>アラート</p>
        </div>
      </div>
      <div v-if="isShowtAlert" style="text-align: left;">
        <b-table :data="this.alartList" detailed class="box">
          <template slot-scope="props">
            <b-table-column
              field="subSystem"
              label="機能"
              :style="subSystemStyle(props.row.subSystem)"
            >{{ props.row.subSystem }}</b-table-column>
            <b-table-column
              field="title"
              label="内容"
              style="font-size: 13.7px;"
            >{{ props.row.title }}</b-table-column>
          </template>
          <template slot="detail" slot-scope="props">
            <span v-for="(item,index) in props.row.list" v-bind:key="index">
              <div class="alarts">
                <div class="columns" v-if="props.row.type==1">
                  <div class="column">受電日： {{item.date}}</div>
                  <div class="column">依頼元営業所名： {{item.inquiryOfficeName}}</div>
                  <div class="column is-one-fifth">
                    <b-button
                      style="float:right;"
                      class="button is-primary"
                      icon-left="mdi mdi-cog"
                      native-type="button"
                      v-on:click="urgentEdit(item.code)"
                    ></b-button>
                  </div>
                </div>
                <div class="columns is-variable is-1" v-if="props.row.type==2">
                  <div style="width:36%;">
                  旅行日：{{item.startDate}}～{{item.endDate}}
                  <span class="tripOffice" v-if="item.tripOfficeUserFlag"/>
                  <span class="targetOffice" v-if="item.editFlag"/>
                  </div>
                  <div style="width:20%;">
                  患者名：{{getRowItem(item.recipientName,10)}}
                  </div>
                  <div style="width:11%;margin-left:5px;">
                  状態：{{item.status|travelStatusFillter}}
                  </div>
                  <div style="width:28%;margin-left:5px;">
                    依頼元営業所：{{getRowItem(item.tripOfficeName,9)}}
                  </div>
                  <div style="width:5%;">
                    <b-button
                      style="float:right;"
                      class="button is-primary"
                      icon-left="mdi mdi-cog"
                      native-type="button"
                      v-on:click="travelEdit(item.domesticTravelCode)"
                    ></b-button>
                  </div>
                </div>
                <div class="columns is-variable is-1" v-if="props.row.type==2" style="margin-bottom:5px;">
                  <div style="width:26%;">
                    依頼先営業所名：
                    <br />
                    <span
                      v-for="(target,index) in item.targetSalesOfficeList "
                      :value="target.targetSalesOfficeName"
                      :key="index"
                    >
                      {{getRowItem(target.targetSalesOfficeName,16)}}
                      <br />
                    </span>
                  </div>
                  <div style="width:9%;">
                    設置依頼：
                    <span
                      v-for="(target,index) in item.targetSalesOfficeList "
                      :value="target.requestFlag"
                      :key="index"
                    >
                      <br>{{target.requestFlag ? "　あり" : "　なし"}}
                    </span>
                  </div>
                  <div style="width:31%;margin-left:2px;">
                    <span style="line-height: 1;">依頼確認状況：</span>
                    <span
                      v-for="(target,index) in item.targetSalesOfficeList "
                      :value="target.confirmationFlag"
                      :key="index"
                    >
                      <br>
                      <b-checkbox
                        v-model="target.confirmationFlag"
                        :disabled="!target.targetSalesOfficeUserFlag"
                        style="margin-right:-15px;"
                      ></b-checkbox>
                      <span style="text-align:left;margin-left:0px;" v-bind:style="addStyleColor(!target.targetSalesOfficeUserFlag)">
                      確認済み<span v-if="target.confirmationStaffName"
                      style="margin-left:5px;">(更新者：{{getRowItem(target.confirmationStaffName, 6)}})</span>
                      </span>
                    </span>
                  </div>
                  <div style="width:29%;margin-left:3px;">
                    <span style="line-height: 1;">設置状況：
                      <span
                        v-for="(target,index) in item.targetSalesOfficeList"
                        :value="target.completeFlag"
                        :key="index"
                      >
                        <br>
                        <b-checkbox
                          v-model="target.completeFlag"
                          :disabled="!target.targetSalesOfficeUserFlag || !target.requestFlag"
                          style="margin-right:-15px;"
                        ></b-checkbox>
                        <span style="text-align:left;margin-left:0px;" v-bind:style="addStyleColor(!target.targetSalesOfficeUserFlag || !target.requestFlag)">
                          完了<span v-if="target.completeStaffName"
                        style="margin-left:5px;"
                        >(更新者：{{getRowItem(target.completeStaffName, 6)}})</span>
                        </span>
                      </span>
                    </span>
                  </div>
                  <div style="width:5%;float:right;margin-top:5px;">
                    <b-button
                      v-if="item.editFlag"
                      style="float:right;"
                      class="button is-primary"
                      native-type="button"
                      v-on:click="save(item.targetSalesOfficeList)"
                    >更新</b-button>
                  </div>
                </div>
                <div class="columns" v-if="props.row.type==3">
                  <div class="column is-2">
                    点検実施予定日：
                    <br />
                    {{item.scheduledDay|invalidFilter()}}
                  </div>
                  <div class="column is-2">
                    患者コード：
                    <br />
                    {{item.recipientCode}}
                  </div>
                  <div class="column is-2">
                    患者名：
                    <br />
                    {{item.patientName}}
                  </div>
                  <div class="column is-2">
                    予約管理番号：
                    <br />
                    {{item.reservationId}}
                  </div>
                  <div class="column is-3" style="width:250px;">
                    依頼先営業所：
                    <br />
                    {{item.crossBorderCofficeTar}}
                  </div>
                  <div class="column">
                  <b-button
                    style="float:right;"
                    class="button is-primary"
                    icon-left="mdi mdi-cog"
                    native-type="button"
                    v-on:click="appointEdit(item.reservationId)"
                  ></b-button>
                  </div>
                </div>
                <div class="columns" v-if="props.row.type==4">
                    <div class="column is-2">
                      点検実施予定日：
                      <br />
                      {{item.scheduledDay|invalidFilter()}}
                    </div>
                    <div class="column is-2">
                      患者コード：
                      <br />
                      {{item.recipientCode}}
                    </div>
                    <div class="column is-2">
                      患者名：
                      <br />
                      {{item.patientName}}
                    </div>
                    <div class="column is-2">
                      予約管理番号：
                      <br />
                      {{item.reservationId}}
                    </div>
                    <div class="column is-3" style="width:250px;">
                      依頼元営業所：
                      <br />
                      {{item.crossBorderCofficeSrc}}
                    </div>
                    <div class="column">
                    <b-button
                      style="float:right;"
                      class="button is-primary"
                      icon-left="mdi mdi-cog"
                      native-type="button"
                      v-on:click="appointEdit(item.reservationId)"
                    ></b-button>
                  </div>
                </div>
                <div class="columns" v-if="props.row.type==5">
                  <div class="column is-one-fifth">
                    <b-button
                      style="float:left;"
                      class="button is-primary"
                      native-type="button"
                      v-on:click="regularDispoSearch"
                    >
                      <span>消耗品発送</span>
                    </b-button>
                  </div>
                </div>
              </div>
            </span>
          </template>
        </b-table>
        <div style="height: 10px;" />
      </div>
      <div v-if="isShowtAlertNoDetail" style="text-align: left;">
        <b-table :data="this.alartListNoDetail" class="box">
          <template slot-scope="props">
            <b-table-column
              field="subSystem"
              label="機能"
              :style="subSystemStyle(props.row.subSystem)"
            >{{ props.row.subSystem }}</b-table-column>
            <b-table-column
              field="title"
              label="内容"
              style="font-size: 13.7px;"
            >{{ props.row.title }}</b-table-column>
            <b-table-column
              v-if="props.row.type==-1"
              field="inspectionReport"
              label=""
              style="font-size: 13.7px;"
            >
              <b-button
                class="button is-primary has-text-centered"
                icon-right="mdi mdi-printer"
                native-type="button"
                v-on:click="transitionReportbatchPrintSearch(props.row)"
              ></b-button>
            </b-table-column>
          </template>
        </b-table>
        <div style="height: 10px;" />
      </div>
      <div class="notice title is-6">お知らせ</div>
      <b-input
        type="textarea"
        v-model="notice"
        class="box"
        style="text-align: left;"
        :readonly="true"
      ></b-input>
      <div style="height: 10px;" />
      <div class="reservationToday title is-6">本日の予定</div>
      <!-- 検索結果 -->
      <appointment1 ref="searchResult1" v-bind:search-conditions="searchConditionsToday" />
      <div style="height: 10px;" />
      <div class="reservationTomorrow title is-6">明日の予定</div>
      <!-- 検索結果 -->
      <appointment2 ref="searchResult2" v-bind:search-conditions="searchConditionsTomorrow" />
      <div style="height: 10px;" />
      <div class="schedule title is-6">点検スケジュール</div>
      <vc-calendar v-if="isShowtSchedule" is-expanded style="width:500px;">
        <template slot="header-title" slot-scope="page">{{page.yearLabel}}年{{page.monthLabel}}</template>
        <template slot="day-content" slot-scope="props">
          <div class="vc-border">
            <div
              style="text-align: left;"
              v-bind:style="addStyleTextColor(props.day.weekday)"
            >{{ props.day.day }}</div>
            <div v-if="isRengeDate(props.day.date)" style="text-align:center;">
              <b-button
                v-if="getCountAppointment(props.day.date) > 0"
                style="width:50px;background: #ff3860;"
                v-on:click="appoint(props.day.date)"
                class="button"
                type="is-link"
                icon-left
                native-type="button"
              >{{getCountAppointment(props.day.date)}}件</b-button>
              <b-button
                v-else
                style="width:50px;"
                v-on:click="appoint(props.day.date)"
                class="button"
                type="is-link"
                icon-left
                native-type="button"
              >{{getCountAppointment(props.day.date)}}件</b-button>
            </div>
            <div v-else style="text-align:center;">
              <b-button
                style="width:50px;"
                class="button"
                type="is-link"
                icon-left
                native-type="button"
                disabled
              ></b-button>
            </div>
          </div>
        </template>
      </vc-calendar>
    </div>
  </div>
</template>

<script>
import appointmentTemplate1 from "../AppAppointmentSearchResult";
import appointmentTemplate2 from "../AppAppointmentSearchResult";
import * as sort from '../../utils/sort.js';
const constInspection = require("../../utils/inspection");
export default {
  name: "InspectorHome",
  props: ["healthCheck"],
  methods: {
    flgCheck: function(list) {
      var result = {
        errFlag:false,
        errMessage:""
      }
      var editTripHistory = list.find((val) => 
      val.targetSalesOfficeUserFlag && val.completeFlag &&(
      !val.requestFlag || !val.confirmationFlag
      ))
      if(editTripHistory){
        result.errFlag = true
        // result.errMessage="以下を確認して、再度更新を行ってください。\n1.「設置依頼」がなしで、\n　「設置状況」が完了になっていないこと\n2.「依頼確認状況」が未確認で、\n　「設置状況」が完了になっていないこと"
        result.errMessage="「設置状況」を完了に更新できるのは、\n「依頼確認状況」が確認済み\nの旅程のみです。"
      }
      return result
    },
    save: function(list) {
      var checkResult = this.flgCheck(list)
      if(checkResult.errFlag){
        this.showErrorMessage(checkResult.errMessage);
        return
      }
      this.travelList = list
      this.regist()
    },
    regist: function() {
      var excuteApi = this.setInstallationTravelPOST;
      var successCallBack = this.setInstallationTravelPOSTSuccess;
      var errorCallBack = this.setInstallationTravelPOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setInstallationTravelPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.travelList));
      return client.apis.apiTravel.setInstallationTravelPOST({
        body: obj
      });
    },
    setInstallationTravelPOSTSuccess: function(result) {
      // 成功メッセージ表示
      this.travelList = []
      this.showSuccess(result);
      let _this = this
      this.apiCall(function(client){
        return client.apis.apiCommon.getAlertsPOST();
      },
      function(result) {
        if (result.obj["travelList"].length > 0) {
          let newList = {
            subSystem: "呼吸",
            title:"対応予定の国内旅行対応が" + result.obj.travelList.length + "件あります。",
            list: result.obj.travelList,
            type: 2
          }
          var index
          for(let i=0; i < _this.alartList.length; i++){
            if(_this.alartList[i].type == 2){
              index = i;
              break;
            }
          }
          _this.alartList.splice(index, 1, newList)
        }
      },
      function(result) {
        _this.showErrorMessage(result);
      });
    },
    setInstallationTravelPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    checkInstallation: function(targetSalesOfficeList) {
      var ans = true
      if (targetSalesOfficeList && targetSalesOfficeList.length > 0){
        for(var index in targetSalesOfficeList){
          if(targetSalesOfficeList[index].requestFlag){
            ans = false
          }
        }
      }
      return ans;
    },
    getOfficeName: function(value) {
      return value.split(",");
    },
    urgentEdit: function(code) {
      this.$router.push({
        name: "AppUrgentEdit",
        params: { patientCode: "", code: code }
      });
    },
    travelEdit: function(domesticTravelCode) {
      this.$router.push({
        name: "AppDomesticTravel",
        params: { type: "edit", domesticTravelCode: domesticTravelCode }
      });
    },
    appointEdit: function(reservationId) {
      this.$router.push({
        name: "AppAppointmentEdit",
        params: { appointmentCode: reservationId, status: "" }
      });
    },
    getRecipientNameMemo: function(value, length) {
      if (value) {
        return value.length > length ? value.substr(0, length) + "..." : value;
      }
      return value;
    },
    consentInfoEdit: function(data) {
      // 同意書情報編集
      this.$router.push({
        name: "AppPatientManagementEditConsentForm",
        params: {
          searchConditions: {},
          code: "",
          prevRoutePath: this.$route.path,
          consentInfo: data,
          isCreated: false
        }
      });
    },
    regularDispoSearch: function() {
      this.$router.push({
        name: "AppRegularDisposablesSearch"
      });
    },
    addStyleTextColor: function(weekday) {
      if (weekday === 1) {
        return {
          color: "red"
        };
      } else if (weekday === 7) {
        return {
          color: "#00c0ff"
        };
      }
    },
    appoint: function(date) {
      var searchCondition = {
        officeCode: "",
        startDate: this.formatDate(date),
        endDate: this.formatDate(date),
        appointmentStatusGroup: ["1", "2", "3"]
      };
      this.$router.push({
        name: "AppAppointmentSearch",
        params: { searchConditions: searchCondition }
      });
    },
    isRengeDate: function(date) {
      if (date > this.lastMonthLastDay && date < this.fourAfterMontFirstDay) {
        return true;
      }
      return false;
    },
    getCountAppointment: function(date) {
      var currentDate = this.formatDate(date);
      if (this.schedule[currentDate]) {
        return this.schedule[currentDate];
      } else {
        return 0;
      }
    },
    getNotice: function() {
      var excuteApi = this.getNoticePOST;
      var successCallBack = this.getNoticeSuccess;
      var errorCallBack = this.getNoticeError;
      // WebAPI Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getNoticePOST: function(client) {
      return client.apis.apiCommon.getAnnouncementPOST({});
    },
    getNoticeSuccess: function(result) {
      this.notice = result.obj.information;
      if (!this.notice) {
        this.notice = "お知らせはありません。";
      }
    },
    getNoticeError: function(result) {
      this.notice = "お知らせを取得できませんでした。";
    },
    getSchedule: function() {
      var excuteApi = this.getAppointmentListPOST;
      var successCallBack = this.getAppointmentListSuccess;
      var errorCallBack = this.getAppointmentLitError;
      // WebAPI Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getAppointmentListPOST: function(client) {
      return client.apis.apiAppointment.getAppointmentListPOST({
        body: {
          startDate: this.formatDate(this.lastMonthLastDay),
          endDate: this.formatDate(this.fourAfterMontFirstDay),
          status: [1, 2, 3, 4]
        }
      });
    },
    getAppointmentListSuccess: function(result) {
      var scheduleResult = result.obj;
      for (let i = 0; i < scheduleResult.length; i++) {
        var targetDate = scheduleResult[i].scheduledDay;
        targetDate = this.formatDate(this.parseDate(targetDate));
        if (this.schedule[targetDate]) {
          this.schedule[targetDate] = this.schedule[targetDate] + 1;
        } else {
          this.schedule[targetDate] = 1;
        }
      }
      this.isShowtSchedule = true;
    },
    getAppointmentLitError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    search: function() {
      // 本日の点検予定検索
      this.$refs.searchResult1.search(this.searchConditionsToday);
      // 明日の点検予定検索
      this.$refs.searchResult2.search(this.searchConditionsTomorrow);
    },
    getAlert: function() {
      var excuteApi = this.getAlertsPOST;
      var successCallBack = this.getAlertsPOSTSuccess;
      var errorCallBack = this.getAlertsPOSTError;
      // WebAPI Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getAlertsPOST: function(client) {
      return client.apis.apiCommon.getAlertsPOST();
    },
    getAlertsPOSTSuccess: function(result) {
      // WebAPI応答内容を画面に設定
      this.getRegularDisposablesStatus();
      if (result.obj["travelList"].length > 0) {
        sort.sortDateString(result.obj["travelList"], "startDate", "YYYY/MM/DD");
        this.alartList.push({
          subSystem: "呼吸",
          title:
            "対応予定の国内旅行対応が" +
            result.obj.travelList.length +
            "件あります。",
          list: result.obj.travelList,
          type: 2
        });
        this.isShowtAlert = true;
      }
      if (result.obj["appointListFrom"].length > 0) {
        this.alartList.push({
          subSystem: "呼吸",
          title:
            "今月越境依頼を予定している予約が" +
            result.obj.appointListFrom.length +
            "件あります。",
          list: result.obj.appointListFrom,
          type: 3
        });
        this.isShowtAlert = true;
      }
      if (result.obj["appointListTo"].length > 0) {
        this.alartList.push({
          subSystem: "呼吸",
          title:
            "今月越境依頼された予約が" +
            result.obj.appointListTo.length +
            "件あります。",
          list: result.obj.appointListTo,
          type: 4
        });
        this.isShowtAlert = true;
      }
    },
    getAlertsPOSTError: function(result) {
      this.showErrorMessage(result);
    },

    getAlertsInspectionReport: function() {
      var excuteApi = this.getAlertsInspectionReportPOST;
      var successCallBack = this.getAlertsInspectionReportPOSTSuccess;
      var errorCallBack = this.getAlertsInspectionReportPOSTError;
      // WebAPI Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
      return;
    },
    getAlertsInspectionReportPOST: function(client) {
      return client.apis.apiInspection.getAlertsInspectionReportPOST();
    },
    getAlertsInspectionReportPOSTSuccess: function(result) {
      // 送付方法の3: 点検報告書送付不要が、検索条件では4を割り当てられているため、
      // 検索条件の4以降のコードは+1する
      if (result.obj.notOutputNum) {
        this.alartListNoDetail.push({
          subSystem: "呼吸",
          title:
            "未確認の報告書が" +
            result.obj.notOutputNum +
            "件あります。",
          type: -1,
          searchConditions: {
            printKindGroup: [
              "" + constInspection.PRINT_TYPE_MAP.hospital.code,
            ],
            formGroup: [
              "" + (constInspection.SEND_TYPE_HOSPITAL_MAP.pcp.code + 1),
              "" + (constInspection.SEND_TYPE_HOSPITAL_MAP.naviexp.code + 1),
            ],
            statusGroup: [
              "" + constInspection.PRINT_STATUS_MAP.notOutput.code,
            ],
            inspectionKindGroup: [
              "" + constInspection.INSPECTION_TYPE_MAP.hospitalMyCompany.code,
              "" + constInspection.INSPECTION_TYPE_MAP.homeMyCompany.code,
              "" + constInspection.INSPECTION_TYPE_MAP.homeDealer.code,
            ],
            officeCode: this.userInfo.officeCode,
            staffCode: this.userInfo.staffCode,
            staffName: this.userInfo.fullName,
          },
        });
        this.isShowtAlertNoDetail = true;
      }

      if (result.obj.confirmedNum) {
        this.alartListNoDetail.push({
          subSystem: "呼吸",
          title:
            "PCP公開が行われていない報告書が" +
            result.obj.confirmedNum +
            "件あります。",
          type: -1,
          searchConditions: {
            printKindGroup: [
              "" + constInspection.PRINT_TYPE_MAP.hospital.code,
            ],
            formGroup: [
              "" + (constInspection.SEND_TYPE_HOSPITAL_MAP.pcp.code + 1),
            ],
            statusGroup: [
              "" + constInspection.PRINT_STATUS_MAP.confirmed.code,
            ],
            inspectionKindGroup: [
              "" + constInspection.INSPECTION_TYPE_MAP.hospitalMyCompany.code,
              "" + constInspection.INSPECTION_TYPE_MAP.homeMyCompany.code,
              "" + constInspection.INSPECTION_TYPE_MAP.homeDealer.code,
            ],
            officeCode: this.userInfo.officeCode,
            staffCode: this.userInfo.staffCode,
            staffName: this.userInfo.fullName,
          },
        });
        this.isShowtAlertNoDetail = true;
      }

      return;
    },
    getAlertsPOSTError: function(result) {
      this.showErrorMessage(result);
      return;
    },
    transitionReportbatchPrintSearch: function (row) {
      this.$router.push({
        name: "AppReportbatchPrintSearch",
        params: {
          searchConditions: row.searchConditions,
        },
      });

      return;
    },

    getRegularDisposablesStatus: function() {
      if (this.fiveDayMonthFlg) {
        var excuteApi = this.getRegularDisposablesStatusPOST;
        var successCallBack = this.getRegularDisposablesStatusPOSTSuccess;
        var errorCallBack = this.getRegularDisposablesStatusPOSTError;
        // WebAPI Call
        this.apiCall(excuteApi, successCallBack, errorCallBack);
      }
    },
    getRegularDisposablesStatusPOST: function(client) {
      var regularDisposablesStatus = 0;
      return client.apis.apiInspection.getRegularDisposablesStatusPOST({
        body: {
          deliveryMonth: this.deliveryMonth,
          status: regularDisposablesStatus
        }
      });
    },
    getRegularDisposablesStatusPOSTSuccess: function(result) {
      // WebAPI応答内容を画面に設定
      var statusResult = result.obj;
      let RegularDisposables = this.alartList.find((elem) => elem.type == 5);
      if (statusResult.length > 0 && !RegularDisposables) {
        this.alartList.push({
          subSystem: "呼吸",
          title:
            this.deliveryMonth + "月分の発送分を５日までに確定してください。",
          list: [""],
          type: 5
        });
        this.isShowtAlert = true;
      }
    },
    getRegularDisposablesStatusPOSTError: function(result) {
      this.showErrorMessage(result);
    },
    getRowItem: function(value, length) {
      return value.length > length ? value.substr(0, length) + "..." : value;
    },
    addStyleColor: function(flg) {
      if(flg){
        return "color:gray"
      }
    },
    subSystemStyle: function(subSystem) {
      let keyName = "breath";
      let style="font-size: 13.7px; color: white; background-color: ";
      if (subSystem == "睡眠") {
        keyName = "sleep";
      }
      style += this.getSubSystemColor(keyName);

      return style;
    },
  },
  data() {
    var alartList = [];
    var healthChecker = this.$props.healthCheck;
    var currentDate = new Date();
    var lastMonthLastDay = new Date(currentDate.setDate(0));
    currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() + 3);
    currentDate.setDate(1);
    var fourAfterMontFirstDay = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate()
    );
    var schedule = [];
    currentDate = new Date();
    currentDate = currentDate.getDate();
    var fiveDayMonthFlg = currentDate < 6;
    var deliveryMonth = this.getDeliveryMonth();
    var today = new Date();
    var searchConditionsToday = {
      startDate: this.formatDate(today),
      endDate: this.formatDate(today),
      officeCode: "",
      appointmentStatusGroup: [1, 2, 3, 4]
    };
    var tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    var searchConditionsTomorrow = {
      startDate: this.formatDate(tomorrow),
      endDate: this.formatDate(tomorrow),
      officeCode: "",
      appointmentStatusGroup: [1, 2, 3, 4],
    };
    const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    return {
      travelList:[],
      alartList,
      lastMonthLastDay: lastMonthLastDay,
      fourAfterMontFirstDay: fourAfterMontFirstDay,
      schedule: schedule,
      notice: "",
      isShowtAlert: false,
      isShowtSchedule: false,
      searchConditions: {
        officeCode: "",
        startDate: "",
        endDate: "",
        staffCode: "",
        staffName: "",
        appointmentStatusGroup: []
      },
      searchConditionsToday,
      searchConditionsTomorrow,
      healthChecker,
      deliveryMonth,
      fiveDayMonthFlg,
      isShowtAlertNoDetail: false,
      alartListNoDetail: [],
      userInfo,
    };
  },
  components: {
    appointment1: appointmentTemplate1,
    appointment2: appointmentTemplate2
  },
  mounted: function() {
    this.alartList = [];
    this.getNotice();
    this.getSchedule();
    this.search();
    this.getAlert();
    this.getAlertsInspectionReport();
  },
  filters: {
    invalidFilter: function(value) {
      if (
        value
          .toString()
          .toLowerCase()
          .replace(" ", "")
          .replace("　", "") == "invaliddate"
      ) {
        return "未定";
      }
      return value;
    }
  }
};
</script>
<style lang="scss" scoped>
.alarts {
  font-size: 13.7px;
  border-bottom: solid 1px;
  margin-top: 30px;
}
.tripOffice::after
{
content: "依頼元";
width:40px;
height: 30px;
background-color: blue;
padding:1px 2px 1px 2px;
margin: -4px 0 0 2px;
font-size: 11px;
color: #ffff;
vertical-align: text-top;
border-radius: 3px;
}
.targetOffice::after
{
content: "依頼先";
width:35;
height: 16px;
background-color: red;
padding:1px 2px 1px 2px;
margin: -4px 0 0 2px;
font-size: 11px;
color: #ffff;
vertical-align: text-top;
border-radius: 3px;
}
</style>


// WEBPACK FOOTER //
// src/components/home/InspectorHome.vue